import classNames from 'classnames'
import { ScreenEnum, useScreen } from 'feature/screenMode'
import { Button, Modal } from 'ui'
import { LoaderInCentalPosition } from 'widget'

import style from './ModalConfirm.module.scss'

type ModalConfirmProps = {
  cancelText: string
  actionText: string
  modalText?: string
  isModalOpen: boolean
  onConfirm: () => void
  onCancel: () => void
  className?: string
  isButtonLoading?: boolean
}
// модальное окно согласия
export function ModalConfirm({
  cancelText,
  actionText,
  modalText,
  isModalOpen,
  onConfirm,
  onCancel,
  className,
  isButtonLoading,
}: ModalConfirmProps) {
  const screen = useScreen()

  return (
    <Modal open={isModalOpen} onClose={onCancel}>
      <div className={classNames(style.modal, className)}>
        <span className={style.title}>
          {modalText || 'Вы действительно хотите выйти?'}
        </span>
        <div className={style.btnWrapper}>
          <Button
            onClick={onCancel}
            variant='contained'
            color='primary'
            className={style.closeBtn}
            disabled={isButtonLoading}
            data-testid='modal-confirm-cancel'
          >
            {cancelText}
          </Button>

          <Button
            onClick={onConfirm}
            {...(screen !== ScreenEnum.mobile && { variant: 'outlined' })}
            color='primary'
            className={style.logoutBtn}
            disabled={isButtonLoading}
            data-testid='modal-confirm-action'
          >
            {isButtonLoading && <LoaderInCentalPosition />}
            {actionText}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
